var exports = {
  "v": "editHeaderWrapper__1ZZaAt",
};

module.exports = exports;
